// app/javascript/modules/ferias/delete_action.js

const MSG_JA_APROVADO =
  "Cancelamentos são permitidos em até 5 dias úteis, devendo o síndico entrar em contato com o Departamento Pessoal pelo e-mail <strong>dp.ferias@protel.com.br</strong>";

function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") ?? "";
}

export function initFeriasDeleteAction(rootEl) {
  async function handler(e) {
    const btn = e.target.closest(".apagar-movimentacao-pessoal");
    if (!btn) return;
    e.preventDefault();

    const aprovado = btn.dataset.aprovado === "true";
    // URL real fica em data-url para evitar navegação padrão via href
    const url = btn.dataset.url;

    if (aprovado) {
      if (typeof window.Swal !== "undefined") {
        await Swal.fire({
          title: "Atenção",
          html: MSG_JA_APROVADO,
          icon: "info",
          confirmButtonText: "OK",
        });
      } else {
        alert("Cancelamentos são permitidos em até 5 dias úteis, devendo o síndico entrar em contato com o Departamento Pessoal pelo e-mail dp.ferias@protel.com.br");
      }
      return;
    }

    if (!url) return;

    let confirmed = false;
    if (typeof window.Swal !== "undefined") {
      const result = await Swal.fire({
        title: "Apagar solicitação?",
        text: "Esta ação não pode ser desfeita.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, apagar",
        confirmButtonColor: "#b91c1c",
        cancelButtonText: "Cancelar",
      });
      confirmed = result.isConfirmed;
    } else {
      confirmed = window.confirm("Apagar esta solicitação? Esta ação não pode ser desfeita.");
    }

    if (!confirmed) return;

    const token = csrfToken();
    try {
      const resp = await fetch(url, {
        method: "DELETE",
        credentials: "same-origin",
        headers: { "X-CSRF-Token": token },
      });
      if (!resp.ok) throw resp;
      window.location.reload();
    } catch {
      if (typeof window.Swal !== "undefined") {
        await Swal.fire({ title: "Erro!", text: "Não foi possível apagar a solicitação.", icon: "error" });
      } else {
        alert("Não foi possível apagar a solicitação.");
      }
    }
  }

  rootEl.addEventListener("click", handler);
  return { destroy() { rootEl.removeEventListener("click", handler); } };
}
